/** A daily puzzle as the web game plays it. Shared by the Worker and the web. */
export interface PagePuzzle {
  number: number;
  date: string;
  answer: string;
  hint: string;
  image: { url: string; width: number; height: number };
  alt: string;
  credit: { author: string; licence: string; sourceUrl: string };
}

export interface PageData {
  /** The game's public address, e.g. "https://whereapp.world". */
  site: string;
  appStoreUrl: string;
  playStoreUrl: string;
  puzzle: PagePuzzle;
  challenge: { name: string | null; score: number | "x" | null };
}

/**
 * The JSON the Worker embeds in the page. `/c/{number}` carries its puzzle; the top of the site
 * carries none, because only the browser knows the visitor's date (see daily.ts).
 */
export type EmbeddedData = Omit<PageData, "puzzle"> & { puzzle: PagePuzzle | null };

export const PAGE_DATA_ID = "page-data";
